module.exports = __webpack_public_path__ + "static/media/icon_public_reporting_left_arrow.b0248c31.svg";